import { AbstractControl } from '@angular/forms';

import { TranslateService } from '@core/services/translate.service';

export interface ControlErrorKeys {
  pattern?: string;
  maxlength?: string;
}

/** Translated validation message for a touched, invalid control; otherwise `undefined`. */
export function controlErrorMessage(
  control: AbstractControl | null,
  fieldLabel: string,
  translate: TranslateService,
  errorKeys: ControlErrorKeys = { pattern: 'COMMON.VALIDATION.HALF_PHONE' },
): string | undefined {
  if (!control?.touched || !control.invalid) return undefined;
  if (control.errors?.['required']) {
    return translate.translate('COMMON.VALIDATION.REQUIRED_FIELD', [fieldLabel]);
  }
  if (control.errors?.['email']) {
    return translate.translate('COMMON.VALIDATION.INVALID_EMAIL');
  }
  if (control.errors?.['pattern'] && errorKeys.pattern) {
    return translate.translate(errorKeys.pattern);
  }
  if (control.errors?.['maxlength'] && errorKeys.maxlength) {
    return translate.translate(errorKeys.maxlength);
  }
  return undefined;
}
